import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';
import { R as ResizeObserver } from './ResizeObserver-24585425.js';
import { b as bem } from './index.esm-7182addc.js';

const gravityTextareaCss = ".gravity-textarea{display:flex;flex-direction:column}.gravity-textarea__container{background-color:#FFFFFF;border-bottom:var(--gravity-textarea-border-bottom, 1px solid rgba(0, 15, 30, 0.2));border-left:var(--gravity-textarea-border-left, 1px solid rgba(0, 15, 30, 0.2));border-radius:var(--gravity-textarea-border-radius, 6px);border-right:var(--gravity-textarea-border-right, 1px solid rgba(0, 15, 30, 0.2));border-top:var(--gravity-textarea-border-top, 1px solid rgba(0, 15, 30, 0.2));box-sizing:border-box;display:flex;flex-direction:row;position:relative}.gravity-textarea__container:focus-within{outline:2px solid #1B6AEE;outline-offset:2px}.gravity-textarea__container:hover{border-color:rgba(0, 15, 30, 0.45)}.gravity-textarea__container .gravity-textarea__textarea{font-feature-settings:\"liga\" on;font-feature-settings:\"liga\" on;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;background-color:inherit;border:0;border-radius:6px;box-sizing:border-box;color:#000F1E;flex:1;font-family:\"Bull\", Helvetica, sans-serif;font-size:16px;line-height:1.5;padding:7px 12px;width:100%}.gravity-textarea__container .gravity-textarea__textarea:invalid{box-shadow:none}.gravity-textarea__container .gravity-textarea__textarea:focus{outline:none}.gravity-textarea__container .gravity-textarea__textarea:hover{outline-color:rgba(0, 15, 30, 0.45)}.gravity-textarea__container .gravity-textarea__textarea::placeholder{color:rgba(0, 15, 30, 0.4)}.gravity-textarea--size-small .gravity-textarea__container{border-radius:var(--gravity-textarea-border-radius, 4px)}.gravity-textarea--size-small .gravity-textarea__textarea{border-radius:4px;font-size:14px;line-height:1.428571;padding:5px 8px}.gravity-textarea--readonly .gravity-textarea__container,.gravity-textarea--disabled .gravity-textarea__container{background-color:rgba(0, 15, 30, 0.05)}.gravity-textarea--readonly .gravity-textarea__container .gravity-textarea__textarea,.gravity-textarea--disabled .gravity-textarea__container .gravity-textarea__textarea{background-color:transparent}.gravity-textarea--readonly .gravity-textarea__container,.gravity-textarea--readonly .gravity-textarea__container:hover,.gravity-textarea--readonly .gravity-textarea__container:focus-within,.gravity-textarea--disabled .gravity-textarea__container,.gravity-textarea--disabled .gravity-textarea__container:hover,.gravity-textarea--disabled .gravity-textarea__container:focus-within{border-color:transparent}.gravity-textarea--readonly .gravity-textarea__textarea::placeholder{color:rgba(0, 15, 30, 0.6);opacity:1 !important}.gravity-textarea--disabled .gravity-textarea__textarea{color:rgba(0, 15, 30, 0.4)}.gravity-textarea--required .gravity-textarea__container{border-color:#DB0A40}.gravity-textarea--invalid .gravity-textarea__container{border-color:#DB0A40}.gravity-textarea--invalid .gravity-textarea__container:hover{border-color:#C3093B}.gravity-textarea--highlighted .gravity-textarea__container{background-color:#F4F8FE}.gravity-textarea--highlighted .gravity-textarea__textarea{color:#175ACA}";
const GravityTextareaStyle0 = gravityTextareaCss;

const generateClassNames = bem('gravity-textarea');
const GravityTextarea = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.inputChanged = createEvent(this, "inputChanged", 7);
        this.resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                const borderBoxSize = entry.borderBoxSize;
                if (!borderBoxSize) {
                    return;
                }
                //we set the desired value here if the component was hidden on componentDidLoad
                if (this.baseScrollHeight === 0) {
                    this.baseScrollHeight = borderBoxSize[0].blockSize;
                    this.calculateRows();
                }
            });
        });
        this.disabled = false;
        this.growable = false;
        this.highlighted = false;
        this.infoBottom = false;
        this.infoPosition = 'top';
        this.infoText = '';
        this.infoWidth = undefined;
        this.inline = false;
        this.inlineLabelWidth = '33%';
        this.invalid = false;
        this.label = '';
        this.placeholder = 'Add a description...';
        this.readonly = false;
        this.required = false;
        this.rows = 7;
        this.size = 'medium';
        this.spellcheck = false;
        this.validationMessage = '';
        this.value = '';
        this.valueMissing = false;
    }
    valueHandler() {
        this.input.value = this.value;
        if (this.growable) {
            this.calculateRows();
        }
        this.validate();
    }
    requiredChangeHandler() {
        if (!this.required && this.valueMissing) {
            this.valueMissing = false;
        }
    }
    /**
     * Resets the input
     */
    async reset() {
        this.valueMissing = false;
        this.invalid = false;
        this.validationMessage = '';
        this.input.value = this.initialValue;
        this.inputChanged.emit(this.input.value);
    }
    validate() {
        if (this.required && this.value === '') {
            this.valueMissing = true;
        }
        else if (this.valueMissing) {
            this.valueMissing = false;
        }
    }
    handleChange($event) {
        this.value = $event.target.value;
        this.inputChanged.emit(this.value);
    }
    calculateRows() {
        this.input.rows = this.minRows;
        const newRows = Math.floor((this.input.scrollHeight - this.baseScrollHeight) / this.lineHeight);
        this.input.rows = this.minRows + newRows;
    }
    componentWillLoad() {
        this.initialValue = this.value;
        this.minRows = this.rows;
    }
    componentDidLoad() {
        this.input.value = this.initialValue;
        this.input.onblur = () => {
            if (!this.readonly && !this.disabled) {
                this.validate();
            }
        };
        this.lineHeight = parseInt(getComputedStyle(this.input).lineHeight, 10);
        if (this.growable) {
            this.resizeObserver.observe(this.input);
            const savedValue = this.input.value;
            this.input.value = '';
            this.baseScrollHeight = this.input.scrollHeight;
            this.input.value = savedValue;
            this.calculateRows();
        }
    }
    render() {
        return (h("gravity-form-field", { key: 'aecad8cba3975f7421da4920c6c7c5e54137b7ba', label: this.label, required: this.required, disabled: this.disabled, highlighted: this.highlighted, infoBottom: this.infoBottom, "info-text": this.infoText, "info-position": this.infoPosition, "info-width": this.infoWidth, inline: this.inline, inlineLabelWidth: this.inlineLabelWidth, size: this.size, invalid: !!this.validationMessage || this.valueMissing, validationMessage: this.validationMessage }, h("div", { key: '9427934f4d6ed32c0a11481db1c3ce8ddafade91', class: generateClassNames({
                inline: this.inline,
                highlighted: this.highlighted,
                readonly: this.readonly,
                disabled: this.disabled,
                required: this.valueMissing,
                invalid: this.invalid || !!this.validationMessage,
                size: this.size,
            }) }, h("div", { key: '43ea2c72bc6cf7caf90b787f40d6018f921fd9f8', class: generateClassNames('container') }, h("textarea", { key: '481533dd0c74525cb5c1cce74177814b7a744d1a', class: generateClassNames('textarea'), spellcheck: this.spellcheck, rows: this.rows, placeholder: this.placeholder, required: this.required, readonly: this.readonly, disabled: this.disabled, onInput: ($event) => this.handleChange($event), ref: (el) => (this.input = el) })))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "value": ["valueHandler"],
        "required": ["requiredChangeHandler"]
    }; }
};
GravityTextarea.style = GravityTextareaStyle0;

export { GravityTextarea as gravity_textarea };

//# sourceMappingURL=gravity-textarea.entry.js.map